/**
 * HTTP request methods.
 *
 * HTTP defines a set of request methods to indicate the desired action to be
 * performed for a given resource. Although they can also be nouns, these
 * request methods are sometimes referred as HTTP verbs. Each of them implements
 * a different semantic, but some common features are shared by a group of them:
 * e.g. a request method can be safe, idempotent, or cacheable.
 *
 */
export let HttpMethod = /*#__PURE__*/function (HttpMethod) {
  HttpMethod["Connect"] = "connect";
  HttpMethod["Delete"] = "delete";
  HttpMethod["Get"] = "get";
  HttpMethod["Head"] = "head";
  HttpMethod["Options"] = "options";
  HttpMethod["Patch"] = "patch";
  HttpMethod["Post"] = "post";
  HttpMethod["Put"] = "put";
  HttpMethod["Trace"] = "trace";
  return HttpMethod;
}({});
//# sourceMappingURL=HttpMethod.js.map